import { render, staticRenderFns } from "./__HistoriesManufacture.vue?vue&type=template&id=0f0beed4&"
import script from "./__HistoriesManufacture.vue?vue&type=script&lang=js&"
export * from "./__HistoriesManufacture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports